import React, { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';

const TextChecker = ({ text, maxLength }) => {
  const [suggestions, setSuggestions] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const checkText = async () => {
      if (!text || text.length < 5) {
        setSuggestions(null);
        return;
      }

      setIsChecking(true);
      try {
        const response = await fetch('/api/check-text', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ text }),
        });

        if (response.ok) {
          const data = await response.json();
          setSuggestions(data.suggestions);
          setShowSuggestions(true);
        }
      } catch (error) {
        console.error('Error checking text:', error);
      } finally {
        setIsChecking(false);
      }
    };

    // Debounce the check to avoid too many API calls
    const timeoutId = setTimeout(checkText, 1000);
    return () => clearTimeout(timeoutId);
  }, [text]);

  if (!suggestions || !showSuggestions) return null;

  return (
    <div className="relative mt-1">
      <div className="absolute z-10 w-full bg-white border border-red-200 rounded-md shadow-lg p-3">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center text-red-500 text-sm">
            <AlertCircle className="w-4 h-4 mr-1" />
            <span>Check wording</span>
          </div>
          <button
            onClick={() => setShowSuggestions(false)}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <ul className="space-y-2">
          {suggestions.map((suggestion, index) => (
            <li key={index} className="text-sm text-gray-600">
              {suggestion}
            </li>
          ))}
        </ul>
        <div className="mt-2 text-right text-xs text-gray-400">
          {text.length}/{maxLength}
        </div>
      </div>
    </div>
  );
};

export default TextChecker; 